<script lang="ts">
    import {onMount} from "svelte";
    import SorryMessageView from "../component/common/Message/SorryMessageView.svelte";


    onMount(() => {
    });


</script>

<div class="not-found-page standard-page">
    <SorryMessageView message="ページが見つかりません"/>


</div>
<style lang="scss">
    .not-found-page {

    }
</style>